import { Button, Form, Space, message, Input, Modal } from "antd";
import dayjs from "dayjs";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useCallback } from "react";
import $axios from "../../services/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleRight,
  faClose,
  faUser,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { DEFAULT_PLACE } from "../../helpers/const";
import {
  getPlaceDetailFromLatLng,
  getPlaceDetailFromPlaceId,
} from "../../helpers/utils";
import axios from "axios";
import _ from "lodash";

const GoongAutocomplete = ({
  value,
  onChange,
  onPlaceSelected,
  error,
  disabled,
  placeholder,
  iconComponent,
  showSuggestions,
  onToggleSuggestions,
  dataPlace,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const fetchSuggestions = async (inputValue, dataPlace) => {
    if (inputValue && inputValue.length > 4) {
      try {
        const params = {
          input: inputValue,
          api_key: process.env.REACT_APP_GOOGNG_API_KEY,
          radius: 20,
        };
        if (dataPlace?.from?.lat && dataPlace?.from?.lng) {
          params.location = dataPlace?.from?.lat + "," + dataPlace?.from?.lng;
        }
        const response = await axios.get(
          `https://rsapi.goong.io/Place/AutoComplete`,
          {
            params: params,
          }
        );
        setSuggestions(response.data.predictions || []);
      } catch (error) {
        console.error("Error fetching Goong places:", error);
      }
    } else {
      setSuggestions([]);
    }
  };
  const debouncedFetchSuggestions = useCallback(
    _.throttle(fetchSuggestions, 1000),
    []
  );

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);
    if (inputValue.length > 0 && onToggleSuggestions) {
      onToggleSuggestions(true); // Mở dropdown khi có input
    }
    debouncedFetchSuggestions(inputValue, dataPlace);
  };

  const handleSelectPlace = async (place) => {
    setSuggestions([]);
    if (onToggleSuggestions) onToggleSuggestions(false); // Đóng dropdown khi chọn
    try {
      const placeDetail = await getPlaceDetailFromPlaceId(place.place_id);
      onPlaceSelected(placeDetail);
    } catch (error) {
      onPlaceSelected(null);
      console.error("Error fetching place details:", error);
    }
  };

  const handleClearSelection = () => {
    onChange("");
    onPlaceSelected(null);
    setSuggestions([]);
  };

  return (
    <div className="autocomplete-container">
      <span className="z-10">{iconComponent}</span>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        className={`${
          error ? "border-error" : ""
        } autocomplete-input focus:border-primary hover:border-primary`}
        disabled={disabled}
        placeholder={placeholder}
        allowClear
      />
      {value && (
        <button
          onClick={handleClearSelection}
          className="absolute top-[50%] right-[8px] border-0 outline-0 w-5 h-10 bg-transparent"
          style={{ transform: "translateY(-50%)" }}
        >
          <FontAwesomeIcon icon={faClose} color="black" />
        </button>
      )}

      {showSuggestions && suggestions.length > 0 && (
        <ul className="autocomplete-suggestions">
          {suggestions.map((place) => (
            <li key={place.place_id} onClick={() => handleSelectPlace(place)}>
              {place.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const Booking = ({
  setLoading,
  loading,
  setDataServices,
  setStep,
  setDataPlace,
  dataPlace,
  dataInputPlace,
  setDataInputPlace,
  isPlaceHistory,
  setIsPlaceHistory,
}) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [showSuggestions, setShowSuggestions] = useState({
    from: false,
    to: false,
  });
  const handleCloseSuggestions = (type) => {
    setShowSuggestions((prev) => ({
      ...prev,
      [type]: false,
    }));
  };
  const [errors, setErrors] = useState({
    from: false,
    to: false,
  });
  const [isModalConfirmInfor, setIsModalConfirmInfor] = useState(false);
  const [form] = Form.useForm();
  const [formContact] = Form.useForm();
  useEffect(() => {
    if (!isPlaceHistory) {
      // Lấy vị trí hiện tại
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            const placeDetail = await getPlaceDetailFromLatLng(
              latitude,
              longitude
            );
            if (placeDetail) {
              onChoosePlace(placeDetail, "from");
            }
          },
          (err) => {
            console.error("Lỗi khi lấy vị trí: ", err.message);
          }
        );
      } else {
        alert("Trình duyệt không hỗ trợ định vị.");
      }
    }
  }, []);

  const onChoosePlace = (item, type = "from" | "to") => {
    setDataInputPlace((prevState) => ({
      ...prevState,
      [type]: item.description,
    }));
    setDataPlace({
      ...dataPlace,
      [type]: {
        place_id: item.place_id,
        description: item.description,
        placeName: item.placeName,
        lat: item.lat,
        lng: item.lng,
        regionName: item.regionName,
      },
    });
    handleCloseSuggestions(type);
    setErrors({ ...errors, [type]: false });
  };

  const handleFinish = async (values) => {
    if (!dataInputPlace.from || !dataInputPlace.to) {
      setErrors({
        ...errors,
        from: !dataInputPlace.from,
        to: !dataInputPlace.to,
      });
      return;
    }

    const isValidFrom =
      !!dataPlace.from &&
      !!dataPlace.from.place_id &&
      !!dataPlace.from.description &&
      !!dataPlace.from.placeName &&
      !!dataPlace.from.lat &&
      !!dataPlace.from.lng &&
      !!dataPlace.from.regionName;

    const isValidTo =
      !!dataPlace.to &&
      !!dataPlace.to.place_id &&
      !!dataPlace.to.description &&
      !!dataPlace.to.placeName &&
      !!dataPlace.to.lat &&
      !!dataPlace.to.lng &&
      !!dataPlace.to.regionName;

    if (!isValidFrom) {
      message.error("Điểm đến không hợp lệ! Vui lòng chọn từ danh sách gợi ý");
      return;
    }

    if (!isValidTo) {
      message.error("Điểm đến không hợp lệ! Vui lòng chọn từ danh sách gợi ý");
      return;
    }
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/api/v1/gsm/services?regionName=${dataPlace.from.regionName}&latitude=${dataPlace.from.lat}&longitude=${dataPlace.from.lng}`
      );
      setDataServices(res.data.data);
      setStep("map");
    } catch (error) {
      message.error(error?.response?.data?.message || "Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalConfirmInfor(false);
  };

  const handleFinishContact = async (values) => {
    // Lấy token từ URL
    const queryParams = new URLSearchParams(window.location.search);
    const IdRequest = queryParams.get("id_request");
    const CifPk = queryParams.get("cif_pk");
    const DeviceId = queryParams.get("device_id");
    const RequestDate = queryParams.get("request_date");
    const Signature = queryParams.get("signature");
    if (IdRequest && CifPk && DeviceId && RequestDate && Signature) {
      const res = await $axios.$post("/api/v1/gsm/login", {
        IdRequest,
        CifPk,
        PartnerId: "NAB",
        DeviceId,
        RequestDate,
        Signature,
        Phone: values.phone,
        FullName: values.fullName,
      });
      const userInfo = res.data.data.userInfo;
      userInfo.phone = userInfo.phone.replace(/^84/, "0");
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      localStorage.setItem("taxiIpassToken", res.data.data.token);
      setIsModalConfirmInfor(false);
      // history.replace({
      //   pathname: location.pathname,
      // });
    }
  };

  const handleSwap = () => {
    const newFrom = dataInputPlace.to;
    const newTo = dataInputPlace.from;

    const newFromPlace = dataPlace.to;
    const newToPlace = dataPlace.from;

    setDataInputPlace({ from: newFrom, to: newTo });
    setDataPlace({ from: newFromPlace, to: newToPlace });

    setErrors({ from: false, to: false });
  };
  return (
    <div className="flex flex-col items-center mt-[0px] step1 booking relative top-[100px]">
      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        initialValues={{
          departDate: dayjs(),
        }}
        onFinishFailed={(values) => {
          setErrors({
            ...errors,
            from: !dataInputPlace.from,
            to: !dataInputPlace.to,
          });
        }}
        className="form-search w-[92%]"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-accent"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 py-5 rounded-2xl"
          >
            <div className="flex gap-4 items-center justify-between">
              <div className="flex flex-col flex-1">
                <Space.Compact
                  className="w-full"
                  direction="horizontal"
                  block={true}
                >
                  <div className="add-start-container">
                    <GoongAutocomplete
                      value={dataInputPlace.from}
                      onChange={(value) =>
                        setDataInputPlace({ ...dataInputPlace, from: value })
                      }
                      dataPlace={dataPlace}
                      placeholder="Điểm đi"
                      error={errors.from}
                      onPlaceSelected={(place) => {
                        setDataPlace({
                          ...dataPlace,
                          from: place ? place : null,
                        });
                        setDataInputPlace({
                          ...dataInputPlace,
                          from: place ? place.description : "",
                        });
                        setIsPlaceHistory(false);
                        setErrors({ ...errors, from: place ? false : true });
                      }}
                      showSuggestions={showSuggestions.from}
                      onToggleSuggestions={(show) =>
                        setShowSuggestions((prev) => ({ ...prev, from: show }))
                      }
                      iconComponent={
                        <svg
                          className="absolute top-[30%] left-3 text-primary"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.49997 10.3847C9.0931 10.3847 10.3846 9.09322 10.3846 7.50009C10.3846 5.90696 9.0931 4.61548 7.49997 4.61548C5.90684 4.61548 4.61536 5.90696 4.61536 7.50009C4.61536 9.09322 5.90684 10.3847 7.49997 10.3847Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <circle
                            cx="7.5"
                            cy="7.5"
                            r="6.75"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                        </svg>
                      }
                    />
                  </div>
                </Space.Compact>
                {errors.from && (
                  <div className="text-[14px] text-[#ff4d4f] self-start">
                    Vui lòng nhập dữ liệu điểm đi!
                  </div>
                )}
                <Space.Compact
                  className="w-full mt-5"
                  direction="horizontal"
                  block={true}
                >
                  <div className="add-end-container">
                    <GoongAutocomplete
                      value={dataInputPlace.to}
                      onChange={(value) =>
                        setDataInputPlace({ ...dataInputPlace, to: value })
                      }
                      dataPlace={dataPlace}
                      placeholder="Điểm đến"
                      error={errors.to}
                      onPlaceSelected={(place) => {
                        setDataPlace({
                          ...dataPlace,
                          to: place ? place : null,
                        });
                        setDataInputPlace({
                          ...dataInputPlace,
                          to: place ? place.description : "",
                        });
                        setIsPlaceHistory(false);
                        setErrors({ ...errors, to: place ? false : true });
                      }}
                      showSuggestions={showSuggestions.to}
                      onToggleSuggestions={(show) =>
                        setShowSuggestions((prev) => ({ ...prev, to: show }))
                      }
                      iconComponent={
                        <svg
                          className="absolute top-[30%] left-3 text-primary"
                          width="16"
                          height="20"
                          viewBox="0 0 16 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.875 7.52969C14.875 12.1875 8 19.0625 8 19.0625C8 19.0625 1.125 12.1875 1.125 7.52969C1.125 3.16031 4.67781 0.625 8 0.625C11.3222 0.625 14.875 3.16031 14.875 7.52969Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </svg>
                      }
                    />
                  </div>
                </Space.Compact>
                {errors.to && (
                  <div className="text-[14px] text-[#ff4d4f] self-start">
                    Vui lòng nhập dữ liệu điểm đến!
                  </div>
                )}
              </div>

              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="cursor-pointer text-primary"
                onClick={() => handleSwap()}
              >
                <circle
                  cx="16"
                  cy="16"
                  r="15.5"
                  fill="white"
                  stroke="currentColor"
                />
                <path
                  d="M17.0678 13.5192C16.7798 13.2312 16.7797 12.7641 17.0678 12.476L20.1842 9.35893C20.4722 9.07084 20.9393 9.07077 21.2274 9.35883L17.0678 13.5192ZM17.0678 13.5192C17.3559 13.8073 17.823 13.8072 18.111 13.5191L19.9684 11.6613L19.9695 22.3477C19.9696 22.755 20.2999 23.0853 20.7072 23.0852C21.1146 23.0852 21.4448 22.7549 21.4448 22.3475L21.4437 11.6612L23.3014 13.5185C23.5895 13.8066 24.0566 13.8065 24.3446 13.5184C24.4886 13.3744 24.5606 13.1854 24.5606 12.9968C24.5606 12.8082 24.4885 12.6192 24.3445 12.4753L21.2274 9.35883L17.0678 13.5192Z"
                  fill="currentColor"
                />
                <path
                  d="M15.4928 18.7088C15.7808 18.9968 15.7809 19.4639 15.4928 19.752L12.3764 22.8691C12.0884 23.1572 11.6213 23.1573 11.3332 22.8692L15.4928 18.7088ZM15.4928 18.7088C15.2047 18.4207 14.7376 18.4208 14.4496 18.7089L12.5922 20.5667L12.5911 9.8803C12.591 9.47299 12.2607 9.1427 11.8534 9.14282C11.446 9.14282 11.1158 9.4731 11.1158 9.88053L11.1169 20.5668L9.25917 18.7095C8.9711 18.4215 8.50402 18.4215 8.21598 18.7096C8.07202 18.8536 7.99998 19.0426 8 19.2312C8.00002 19.4198 8.0721 19.6088 8.21614 19.7527L11.3332 22.8692L15.4928 18.7088Z"
                  fill="currentColor"
                />
              </svg>
            </div>

            <Button
              type="primary"
              htmlType="sumit"
              loading={loading}
              style={{ height: 48 }}
              className="w-full h-[48px] mt-4"
            >
              <span className="text-[16px] font-semibold">Đặt Xe</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => setStep("history")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
      </Form>
      <div className="text-center my-6">
        <span className="text-[#808080] font-normal">
          Hotline hỗ trợ khách hàng{" "}
        </span>
        <a href="tel:1900255585" className="font-bold text-primary text-[16px]">
          1900255585
        </a>
      </div>
      <div className="flex flex-col items-center w-full gap-4">
        {DEFAULT_PLACE.map((item, index) => (
          <div
            onClick={() => onChoosePlace(item, "to")}
            key={index}
            className="flex gap-2 w-full justify-center px-4"
          >
            <div className="w-[20px]">
              <svg
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.79727 20.2298C7.00612 20.2298 3.23217 15.6148 2.24019 14.007C0.816937 11.7003 0 10.3422 0 7.77778C0 3.48223 3.49096 0 7.79727 0C12.1036 0 15.5945 3.48223 15.5945 7.77778C15.5945 10.3289 14.7129 11.6961 13.2849 14.007C12.3559 15.5104 8.58842 20.2298 7.79727 20.2298ZM7.79727 11.6667C9.95043 11.6667 11.6959 9.92555 11.6959 7.77778C11.6959 5.63 9.95043 3.88889 7.79727 3.88889C5.64411 3.88889 3.89864 5.63 3.89864 7.77778C3.89864 9.92555 5.64411 11.6667 7.79727 11.6667Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="ml-2 flex-1 gap-2 flex flex-col">
              <div className="text-[14px] font-medium">{item.placeName}</div>
              <div className="border-b-[1px] border-solid border-0 pb-4 border-[#D1D5DB]">
                <span className="text-[12px] font-normal">
                  {item.description}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal
        title={
          <div className="text-primary text-[20px] font-bold">
            Xác nhận thông tin
          </div>
        }
        open={isModalConfirmInfor}
        footer={null}
        style={{ top: 0, padding: 0 }}
        width="100vw"
        bodyStyle={{
          padding: 0,
          margin: 0,
          overflow: "hidden",
        }}
        centered={true}
        closable={false}
      >
        <Form
          form={formContact}
          onFinish={handleFinishContact}
          layout="vertical"
          onFinishFailed={(values) => {}}
          className="w-full"
          initialValues={{
            fullName: userInfo?.fullName || "",
            phone: userInfo?.phone || "",
          }}
        >
          <div className="w-full">
            <Form.Item
              name="fullName"
              label="Họ và tên"
              rules={[
                {
                  required: true,
                  message: "Họ và tên không được để trống",
                },
              ]}
              className="mb-3 w-full"
            >
              <Input
                size="large"
                prefix={
                  <FontAwesomeIcon icon={faUser} className="text-primary" />
                }
                placeholder="Họ và tên"
                allowClear
              />
            </Form.Item>
          </div>
          <Form.Item
            name="phone"
            label="Số điện thoại"
            rules={[
              {
                required: true,
                message: "Số điện thoại không được để trống",
              },
              {
                pattern: /^(03|05|07|08|09)\d{8}$|^\+84\d{9}$/,
                message: "Số điện thoại không hợp lệ",
              },
            ]}
            className="mb-5 w-full"
          >
            <Input
              size="large"
              prefix={
                <FontAwesomeIcon icon={faPhone} className="text-primary" />
              }
              placeholder="Nhập số điện thoại..."
              allowClear
              className="!hover:border-primary !focus:border-primary !ring-0"
            />
          </Form.Item>
          <div className="flex justify-between gap-4 py-4">
            <Button
              color="danger"
              variant="filled"
              style={{ height: 48 }}
              onClick={handleCancel}
            >
              <span className="text-[18px] font-bold">Huỷ</span>
            </Button>
            <Button
              htmlType="sumit"
              type="primary"
              style={{ height: 48 }}
              className="flex-1"
              loading={loading}
            >
              <span className="text-[18px] font-bold text-white">
                Xác nhận thông tin
              </span>
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Booking;
